import { I18N_FORMAT_MAP } from '@rover/kibble/styles';
import { DEFAULT_LANG } from '@rover/shared/js/constants/i18n/language';

const getLocalizedFormatContextless = (format: string, lang?: string): string => {
  const langs = I18N_FORMAT_MAP[(lang || '').toLowerCase()] || I18N_FORMAT_MAP[DEFAULT_LANG];
  return langs[format] || I18N_FORMAT_MAP[DEFAULT_LANG][format] || format;
};

export default getLocalizedFormatContextless;
